export enum EmergencyPanelState {
    List = 'List',
    Details = 'Details'
}
